import _ from 'lodash';
import {
    SELECT_OR_DESELECT_CATEGORY, SET_CATEGORIES,
    SET_NEW_CATEGORY_ADD_FLAG, SET_CATEGORY_JSON,
    APPEND_NEWLY_ADDED_CATEGORY,
    DELETE_CATEGORY,
    SET_CATEGORY_IN_EDIT,
    CANCEL_CATEGORY_EDIT,
    UPDATE_CATEGORY,
    CLEAR_PERSISTED_CATEGORY_DATA,
    SET_JSON_FROM_SELECTED_GLOBAL_CATEGROY
} from './../actions';


const initialState = {
    categories: [],
    selectedCategoryId: "",
    isAddOrEditActive: false,
    categoryJson: {}
}

const categoryReducer = (state = initialState,  { type, payload }) => {

    let updatedCategoriesList = [];

    switch (type) {

        case SET_CATEGORIES:
        return { ...state, categories: payload };

        case SET_JSON_FROM_SELECTED_GLOBAL_CATEGROY:
        return { ...state, categoryJson: payload, isAddOrEditActive: true, selectedCategoryId: "" };

        case SELECT_OR_DESELECT_CATEGORY:
        return { ...state, selectedCategoryId: !_.isEmpty(payload) ? payload : "" };

        case SET_NEW_CATEGORY_ADD_FLAG:
        return { ...state, isAddOrEditActive: payload, selectedCategoryId: "", categoryJson: {} };

        case SET_CATEGORY_JSON:
        return { ...state, categoryJson: payload };
        
        case APPEND_NEWLY_ADDED_CATEGORY:
            updatedCategoriesList = _.cloneDeep(state.categories);
            updatedCategoriesList.push(payload);
        return { ...state, categoryJson: {}, isAddOrEditActive: false, selectedCategoryId: "", categories: updatedCategoriesList };

        case DELETE_CATEGORY:
            updatedCategoriesList = _.cloneDeep(state.categories);
            updatedCategoriesList = updatedCategoriesList.filter((item) => item.id !== payload);
        return { ...state, categories: updatedCategoriesList, selectedCategoryId: '' };

        case SET_CATEGORY_IN_EDIT:
        return { ...state, isAddOrEditActive: true, selectedCategoryId: payload };

        case CANCEL_CATEGORY_EDIT:
            updatedCategoriesList = _.cloneDeep(state.categories);
            updatedCategoriesList.map(category => {
                if(category.id === state.selectedCategoryId) {
                    category.categoryJson = payload
                }
            });
        return { ...state, isAddOrEditActive: false, categoryJson: payload, categories: updatedCategoriesList };

        case UPDATE_CATEGORY:
            updatedCategoriesList = _.cloneDeep(state.categories);
            updatedCategoriesList.map(category => {
                if(category.id === state.selectedCategoryId) {
                    category.name = payload.name;
                    category.categoryJson = payload.json
                }
            });
        return { ...state, categories: updatedCategoriesList, isAddOrEditActive: false, categoryJson: payload.json };

        case CLEAR_PERSISTED_CATEGORY_DATA:
        return { ...initialState };

        default:
            return state;
    }
}

export default categoryReducer;